<script>
import {
  helpers,
  maxValue,
  minValue,
  required,
  requiredIf
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
let minValueTo = function(design, minValue) {
  return helpers.withParams(
    {
      type: "minValue",
      min: minValue
    },
    function(value, object) {
      let prevTier = design.tiers[design.tiers.indexOf(object) - 1];
      let isLast = design.tiers.length - 1 === design.tiers.indexOf(object);
      let min = prevTier ? prevTier.yos_upper_limit : 0;
      if (isLast) min = min - 1;
      return (
        !helpers.req(value) ||
        ((!/\s/.test(value) || value instanceof Date) && +value > +min)
      );
    }
  );
};

export default {
  computed: {
    ...mapGetters(["complianceLimits"])
  },
  methods: {
    employerMatchValidations(design) {
      if (!this.showForm(design))
        return {
          plan_has_employer_matching_contributions_picklist_id: { required }
        };
      return {
        plan_has_employer_matching_contributions_picklist_id: { required },
        age_requirement_employer_match: { required },
        age_requirement_match_years: {
          required: requiredIf(() => this.showAgeRequirement(design)),
          minValue: minValue(design.age_requirement_years || 0),
          maxValue: maxValue(design.age_requirement_match_months > 0 ? 20 : 21)
        },
        age_requirement_match_months: {
          required: requiredIf(() => this.showAgeRequirement(design)),
          minValue: minValue(design.age_requirement_years < design.age_requirement_match_years ? 0 : design.age_requirement_months || 0),
          maxValue: maxValue(design.age_requirement_match_years > 20 ? 0 : 12)
        },
        service_requirement_employer_match: { required },
        service_requirement_match_measurement_number: {
          required: requiredIf(() => this.showServiceRequirement(design)),
          minValue: minValue(
            design.service_requirement_measurement_number || 0
          ),
          maxValue: maxValue(12)
        },
        employer_match_type: { required },
        employer_match_funding_frequency: { required },
        employer_match_post_tax_contributions: { required },
        employer_match_yos_vary_ee: { required },
        employer_match_contribution_type: { required },
        match_contrib_based_yos_yesno: { required },
        employer_match_number_tiers: {
          required,
          minValue: minValue(this.showTierYosUpperLimit(design) ? 2 : 1)
        },
        tiers: {
          $each: {
            matching_amount: {
              required,
              minValue: minValue(0.01),
              maxValue: maxValue(5),
              percent: true
            },
            deferral_rate: {
              required: requiredIf(() => this.showTierDeferralRate(design)),
              minValue: minValue(0.01),
              maxValue: maxValue(0.15),
              percent: true
            },
            contribution_amount: {
              required: requiredIf(() =>
                this.showTierContributionAmount(design)
              ),
              minValue: minValue(1),
              maxValue: maxValue(this.complianceLimits.max_deferral),
              currency: true
            },
            yos_upper_limit: {
              required: requiredIf(() => this.showTierYosUpperLimit(design)),
              minValue: minValueTo(design, 1),
              maxValue: maxValue(10)
            }
            // applicable_year: {
            //   required: requiredIf(() => this.showTierApplicableYear(design))
            // }
          }
        },
        employer_match_dollar_maximum: {
          required: requiredIf(() => this.showDollarLimit(design))
        },
        match_dollar_limit_amount: {
          required: requiredIf(() => this.showDollarLimitAmount(design)),
          minValue: minValue(0),
          maxValue: maxValue(this.complianceLimits.max_contribution_dc_plan),
          currency: true
        },
        match_on_catch_up_contributions_yesno: { required },
        employer_match_true_up: { required },
        s_147_employer_match_trueup_frequency: {
          required: requiredIf(() => this.showFrequency(design))
        },
        employer_match_annual_service_reqt: { required },
        match_hours_requirement: {
          required: requiredIf(() => this.showHoursOrMonths(design)),
          minValue: minValue(1),
          maxValue: maxValue(
            +design.employer_match_annual_service_reqt === 1 ? 12 : 1000
          )
        },
        match_require_last_day: { required },
        match_excludes_overtime_comp_yesno: { required },
        match_excludes_bonus_comp_yesno: { required },
        match_excludes_commissions_comp_yesno: { required },
        match_excludes_shiftdifferential_comp_yesno: { required },
        percent_match_vesting_immediate: { required },
        percent_match_vesting_1_year: {
          required: requiredIf(
            () =>
              this.showVestingImmediateGraded(design) ||
              this.showVestingImmediateCliff(design)
          ),
          minValue: minValue(0),
          maxValue: maxValue(1),
          percent: true
        },
        percent_match_vesting_2_year: {
          required: requiredIf(
            () =>
              this.showVestingImmediateGraded(design) ||
              this.showVestingImmediateCliff(design)
          ),
          minValue: minValue(this.minVestingYears(design, 2)),
          maxValue: maxValue(1),
          percent: true
        },
        percent_match_vesting_3_year: {
          required: requiredIf(
            () =>
              this.showVestingImmediateGraded(design) ||
              this.showVestingImmediateCliff(design)
          ),
          minValue: minValue(
            this.showVestingImmediateCliff(design)
              ? 1
              : this.minVestingYears(design, 3)
          ),
          maxValue: maxValue(1),
          percent: true
        },
        percent_match_vesting_4_year: {
          required: requiredIf(() => this.showVestingImmediateGraded(design)),
          minValue: minValue(this.minVestingYears(design, 4)),
          maxValue: maxValue(1),
          percent: true
        },
        percent_match_vesting_5_year: {
          required: requiredIf(() => this.showVestingImmediateGraded(design)),
          minValue: minValue(this.minVestingYears(design, 5)),
          maxValue: maxValue(1),
          percent: true
        },
        percent_match_vesting_6_year: {
          required: requiredIf(() => this.showVestingImmediateGraded(design)),
          minValue: minValue(1),
          maxValue: maxValue(1),
          percent: true
        }
      };
    },
    showForm(design) {
      return (
        +design.plan_has_employer_matching_contributions_picklist_id === 1 ||
        +design.plan_has_employer_matching_contributions_picklist_id === 2
      );
    },
    showAgeRequirement(design) {
      return (
        design.age_requirement_employer_match &&
        (+design.age_requirement_employer_match !== 0 &&
          +design.age_requirement_employer_match !== 1)
      );
    },
    showServiceRequirement(design) {
      return (
        design.service_requirement_employer_match &&
        (+design.service_requirement_employer_match !== 0 &&
          +design.service_requirement_employer_match !== 1)
      );
    },
    showTierInputs(design) {
      return design.employer_match_number_tiers > 0;
    },
    showTierDeferralRate(design) {
      return +design.employer_match_contribution_type === 1;
    },
    showTierContributionAmount(design) {
      return +design.employer_match_contribution_type === 2;
    },
    showTierApplicableYear(design) {
      return +design.match_contrib_based_yos_yesno === 1;
    },
    showTierYosUpperLimit(design) {
      return design.employer_match_yos_vary_ee === "yes";
    },
    isLastTier(design, index) {
      return index === design.tiers.length - 1;
    },
    isFirstTier(design, index) {
      return index !== 0;
    },
    showDollarLimit(design) {
      return this.showTierDeferralRate(design);
    },
    showDollarLimitAmount(design) {
      return (
        this.showDollarLimit(design) &&
        +design.employer_match_dollar_maximum === 1
      );
    },
    showFrequency(design) {
      return design.employer_match_true_up === "yes";
    },
    showHours(design) {
      return +design.employer_match_annual_service_reqt === 2;
    },
    showMonths(design) {
      return +design.employer_match_annual_service_reqt === 1;
    },
    showHoursOrMonths(design) {
      return this.showHours(design) || this.showMonths(design);
    },
    showVestingImmediateGraded(design) {
      return +design.percent_match_vesting_immediate === 2;
    },
    showVestingImmediateCliff(design) {
      return +design.percent_match_vesting_immediate === 1;
    },
    minVestingYears(design, number) {
      let value = +design[`percent_match_vesting_${number - 1}_year`] || 0;
      value = value >= 1 ? 1 : value;
      return this.showVestingImmediateCliff(design) ||
        value >= this.minDefaultVesting(number)
        ? value
        : this.minDefaultVesting(number);
    },
    minDefaultVesting(number) {
      switch (number) {
        case 2:
          return 0.2;
        case 3:
          return 0.4;
        case 4:
          return 0.6;
        case 5:
          return 0.8;
        default:
          return 0;
      }
    }
  }
};
</script>
